<div *ngIf="parent != undefined && parent.id == parent.selection">
    <device-events [device]="device">

    </device-events>
</div>